import { useState } from "react";
import { Link } from "wouter";
import { SEOHead } from "../components/SEOHead";
import { ScrollingImageStrip } from "../components/ScrollingImageStrip";
import { FooterPixCapture } from "../components/FooterPixCapture";
import { Menu, X } from "lucide-react";
import { pixCaptureImages, formatForScrollingStrip } from "../data/images";

export default function PixCaptureHome() {
  const [menuOpen, setMenuOpen] = useState(false);

  // Bilder aus zentraler Bildverwaltung laden
  const pixImages = formatForScrollingStrip(pixCaptureImages);

  return (
    <div className="bg-[var(--color-white)]">
      <SEOHead
        title="pixcapture.app – Immobilienfotos selbst erstellen"
        description="Self-Service-Plattform für Immobilienfotografie. Mit dem iPhone fotografieren, hochladen und professionell bearbeiten lassen."
        path="/"
      />

      {/* Logo und Hamburger Menu - Fixed Top */}
      <div className="fixed top-6 left-8 right-8 z-50 flex items-center justify-between">
        {/* Logo als Home-Button */}
        <Link href="/">
          <h1 className="text-[24px] font-medium tracking-[0.05em] cursor-pointer text-[var(--color-black)] leading-none hover:text-[var(--color-grey)] transition-colors">
            pixcapture.app
          </h1>
        </Link>
        
        {/* Hamburger Menu */}
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="p-2 text-[var(--color-black)]"
          aria-label="Menu"
        >
          {menuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="fixed top-20 right-8 z-50 bg-[var(--color-white)] border border-[var(--color-light-grey)] shadow-lg">
          <nav className="flex flex-col px-8 py-6 gap-6">
            <Link href="/app/upload">
              <span
                className="text-[16px] text-[var(--color-black)] cursor-pointer tracking-[-0.02em] hover:text-[var(--color-grey)] transition-colors"
                onClick={() => setMenuOpen(false)}
              >
                Upload
              </span>
            </Link>
            <Link href="/help">
              <span
                className="text-[16px] text-[var(--color-black)] cursor-pointer tracking-[-0.02em] hover:text-[var(--color-grey)] transition-colors"
                onClick={() => setMenuOpen(false)}
              >
                Hilfe
              </span>
            </Link>
            <Link href="/expert-call">
              <span
                className="text-[16px] text-[var(--color-black)] cursor-pointer tracking-[-0.02em] hover:text-[var(--color-grey)] transition-colors"
                onClick={() => setMenuOpen(false)}
              >
                Expertengespräch
              </span>
            </Link>
            <Link href="/about">
              <span
                className="text-[16px] text-[var(--color-black)] cursor-pointer tracking-[-0.02em] hover:text-[var(--color-grey)] transition-colors"
                onClick={() => setMenuOpen(false)}
              >
                About
              </span>
            </Link>
            <Link href="/app/login">
              <span
                className="text-[16px] text-[var(--color-black)] cursor-pointer tracking-[-0.02em] hover:text-[var(--color-grey)] transition-colors"
                onClick={() => setMenuOpen(false)}
              >
                Login
              </span>
            </Link>
          </nav>
        </div>
      )}

      {/* Main viewport section - h-screen */}
      <div className="h-screen flex flex-col">
        {/* White space above */}
        <div className="h-[calc(65vh+31px)]"></div>

        {/* Spacer wo Logo war - kann entfernt werden */}
        <div className="pl-8">
          <div className="h-[56px]"></div>
        </div>

        {/* Spacer to push buttons and strip to bottom */}
        <div className="flex-1"></div>

        {/* Navigation Buttons - Above Strip (Desktop only) */}
        <nav className="hidden lg:flex items-center justify-start gap-6 pb-6 pl-8 bg-[var(--color-white)] h-[40px]">
          <Link href="/app/upload">
            <span className="text-[16px] text-[var(--color-black)] hover:text-[var(--color-grey)] transition-colors cursor-pointer tracking-[0.12em]">
              Upload
            </span>
          </Link>
          <Link href="/help">
            <span className="text-[16px] text-[var(--color-black)] hover:text-[var(--color-grey)] transition-colors cursor-pointer tracking-[0.05em]">
              Hilfe
            </span>
          </Link>
          <Link href="/expert-call">
            <span className="text-[16px] text-[var(--color-black)] hover:text-[var(--color-grey)] transition-colors cursor-pointer tracking-[0.05em]">
              Expertengespräch
            </span>
          </Link>
          <Link href="/about">
            <span className="text-[16px] text-[var(--color-black)] hover:text-[var(--color-grey)] transition-colors cursor-pointer tracking-[0.05em]">
              About
            </span>
          </Link>
          <Link href="/app/login">
            <span className="text-[16px] text-[var(--color-black)] hover:text-[var(--color-grey)] transition-colors cursor-pointer tracking-[0.05em]">
              Login
            </span>
          </Link>
        </nav>

        {/* Scrolling Image Strip */}
        <div className="flex-shrink-0">
          <ScrollingImageStrip images={pixImages} duration={120} clickable={false} />
        </div>
      </div>

      <FooterPixCapture />
    </div>
  );
}
